/* tslint:disable */
/* eslint-disable */
/**
 * driverRegistration driver-registration-portal api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { DriverRegistrationVariant } from './DriverRegistrationVariant';

export interface DriverProvisionalRegistrationStartRegistrationRequest {
    city_id: number;
    /** min length: 0, max length: 255 */
    email: string;
    /** min length: 0, max length: 255 */
    phone: string;
    /** min length: 0, max length: 255 */
    first_name?: string;
    /** min length: 0, max length: 255 */
    last_name?: string;
    has_car?: 0 | 1 | null;
    terms_consent_accepted?: 0 | 1 | null;
    app_version?: string;
    whatsapp_opt_in?: 0 | 1;
    /** min length: 0, max length: 45 */
    referral_code?: string;
    variant?: DriverRegistrationVariant;
}
